function Arrow({
  className,
  direction = 'left',
  color = 'currentColor',
}: {
  className?: string
  direction?: 'left' | 'right'
  color?: string
}) {
  return direction === 'left' ? (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
    >
      <g fill="none" fillRule="evenodd">
        <path fill="none" d="M0 0h32v32H0z" />
        <path
          fill={color}
          d="M8.742 15.001l7.17-6a.25.25 0 0 0 .029-.352l-.969-1.146a.25.25 0 0 0-.352-.029l-9.266 7.762c-.472.4-.472 1.13 0 1.53l9.266 7.762a.25.25 0 0 0 .352-.029l.969-1.145a.251.251 0 0 0-.029-.353l-7.17-6H26.75a.25.25 0 0 0 .25-.25v-1.5a.25.25 0 0 0-.25-.25H8.742z"
        />
      </g>
    </svg>
  ) : direction === 'right' ? (
    <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M19.9845 11.4275L13.0357 5.60529C12.957 5.53854 12.8385 5.54829 12.7718 5.62779L12.045 6.48729C11.9775 6.56604 11.988 6.68379 12.0667 6.75129L17.4435 11.2513H3.9375C3.834 11.2513 3.75 11.3353 3.75 11.4388V12.5638C3.75 12.6673 3.834 12.7513 3.9375 12.7513H17.4435L12.0667 17.2513C11.988 17.318 11.9775 17.4365 12.045 17.5153L12.7718 18.3748C12.8385 18.4535 12.957 18.4633 13.0357 18.3965L19.9845 12.5743C20.3393 12.2743 20.3393 11.7275 19.9845 11.4275Z" fill={color} />
    </svg>
  ) : null
}

export default Arrow
